import AbstractService, {
  InterfaceSystem,
  ServiceSystem
} from "./AbstractService";

/**
 * SystemService
 */
export default class SystemService extends AbstractService implements InterfaceSystem {
  /**
   * ServiceSystem
   */
  static service: ServiceSystem;

  /**
   * constructor
   */
  constructor() {
    super();

    SystemService.service = this.getApi().getServiceSystem();
  }

  /**
   * clearAll
   */
  clearAll(): void {
    SystemService.service.clearAll();
  }

  /**
   * getAllEnums
   */
  getAllEnums(): Promise<any> {
    return SystemService.service.getAllEnums();
  }

  /**
   * getEnumArticleIdentifiers
   */
  getEnumArticleIdentifiers(): Promise<any> {
    return SystemService.service.getEnumArticleIdentifiers();
  }

  /**
   * getEnumInterlinkModulTypes
   */
  getEnumInterlinkModulTypes(): Promise<any> {
    return SystemService.service.getEnumInterlinkModulTypes();
  }

  /**
   * getEnumInterlinkModulTypeById
   * @param id
   */
  getEnumInterlinkModulTypeById(id: string): Promise<any> {
    return SystemService.service.getEnumInterlinkModulTypeById(id);
  }

  /**
   * getEnumPartnerPartnerStatus
   */
  getEnumPartnerPartnerStatus(): Promise<any> {
    return SystemService.service.getEnumPartnerPartnerStatus();
  }

  /**
   * getEnumPluginTypes
   */
  getEnumPluginTypes(): Promise<any> {
    return SystemService.service.getEnumPluginTypes();
  }

  /**
   * getEnumPermissions
   */
  getEnumPermissions(): Promise<any> {
    return SystemService.service.getEnumPermissions();
  }

  /**
   * getEnumRoles
   */
  getEnumRoles(): Promise<any> {
    return SystemService.service.getEnumRoles();
  }

  /**
   * getPasswordRequirements
   */
  getPasswordRequirements(): Promise<any> {
    return SystemService.service.getPasswordRequirements();
  }
}
